export default "__VITE_ASSET__D9LsMbM4__"